import React, { useState } from 'react'
import { Button,Form } from 'antd'
import { connect } from 'react-redux'

import {RefreshIco} from '../../../../../../modules/CustomIcons'

import '../index.scss'
import '../../../../Transfer/transfer.scss'

import { OWNACCOUNT, BUTTONS } from 'constants/constants'
import { useTranslation } from 'react-i18next'

const TransferBottom: React.FC<any> = (props) => {
  const {t} = useTranslation()
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()


  return (
    <>
        <div className="flex" style={{ float: 'right' }}>
          <div className="salary-btns">
            <Button
              size={'large'}
              icon={<RefreshIco />}
              onClick={props.handleReset}
              className="light-button refresh_btn btn flex align_center justify_center"
            >
              {t(OWNACCOUNT.REFRESH)}
            </Button>
            <Button
              size={'large'}
              // onClick={() => setVisibleModal(true)}
              onClick={props.checkSalary}
              htmlType="submit"
              disabled={props.hasErrorAcc}
              className="blue-button next_btn btn flex align_center justify_center"
            >
              {t(BUTTONS.CHECK_ACCOUNTS)}
            </Button>

            <Button
              size={'large'}
              htmlType="button"
              disabled={props.hasError}
              onClick={props.handleSalarySubmit}
              // form="myForm" key="submit"
              // onClick={() => setTextVisibleModal(true)}
              className="blue-button next_btn btn flex align_center justify_center"
            >
              {t(OWNACCOUNT.NEXT)}
            </Button>
          </div>
        </div>
    </>
  )
}
// const mapStateToProps = (state: any) => ({
//   account:  state.salary.selectedItem,
//   tableValue: state.salary.tableValue
// })
export default connect(null, null)(TransferBottom)
